import type { TFunction } from 'i18next';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';

import type { IColumn } from '@feathr/components';
import { ContextMenu, Pill, TableColumnHeader, Text } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import DemoMenuItem from '../components/DemoMenuItem';
import type { ISampleSegment } from '../sampleData';
import buildOptionsColumn from './buildOptionsColumn';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

interface ISegmentColumnsArgs {
  base: string;
  t: TFunction;
}

function segmentColumns({ base, t }: ISegmentColumnsArgs): Array<IColumn<ISampleSegment>> {
  return [
    {
      accessor: 'name',
      id: 'name',
      Header: TableColumnHeader({ title: t('Name'), sortType: 'alpha' }),
      headerClassName: tableStyles.sort,
      className: tableStyles.cell,
      sortable: true,
      minWidth: 280,
      Cell({ original }): JSX.Element {
        return <Link to={base}>{original.name}</Link>;
      },
    },
    {
      accessor: 'description',
      id: 'description',
      Header: TableColumnHeader({ title: t('Description'), sortType: 'alpha' }),
      headerClassName: tableStyles.sort,
      className: tableStyles.cell,
      sortable: true,
      Cell({ original }): JSX.Element {
        return <Text variant={'smallRegular'}>{original.description}</Text>;
      },
    },
    {
      accessor: 'size',
      id: 'size',
      Header: TableColumnHeader({ title: t('People'), sortType: 'numeric' }),
      headerClassName: tableStyles.sort,
      className: tableStyles.cellRight,
      sortable: true,
      width: 140,
      Cell({ original }): JSX.Element {
        return <Pill theme={'sky'}>{numeral(original.size).format('0,0')}</Pill>;
      },
    },
    buildOptionsColumn<ISampleSegment>({
      t,
      renderItems: (): JSX.Element => (
        <>
          <ContextMenu.Item link={base} prefix={getIconForAction('edit')}>
            {t('Edit')}
          </ContextMenu.Item>
          <DemoMenuItem action={'duplicate'} label={t('Duplicate')} />
          <DemoMenuItem action={'archive'} isDestructive={true} label={t('Archive')} />
        </>
      ),
    }),
  ];
}

export default segmentColumns;
